import { useMemo, useCallback, ChangeEvent, useEffect } from 'react'

import { useAppDispatch, useAppSelector } from 'redux/toolkit/hooks'
import { MicrosoftVerifiedDomain } from 'types/emailServer'
import { setMsDomainName } from 'redux/features/emailServer/emailServerSlice'
import { trackEventInAllServices, TRACKING_EVENTS } from 'lib/monitoring/monitoringService'

export interface State {
  msDomainName?: string
  verifiedDomains: MicrosoftVerifiedDomain[]
}

export interface EventHandlers {
  onSelectChange: (e: ChangeEvent<HTMLInputElement>) => void
}

export type UseVerifyMsDomainLogic = [State, EventHandlers]

export const useVerifyMsDomainLogic = (): UseVerifyMsDomainLogic => {
  const dispatch = useAppDispatch()

  const { msDomainName, verifiedDomains } = useAppSelector(_store => ({
    msDomainName: _store.emailServer.msDomainName,
    verifiedDomains: _store.emailServer.emailServerSettings?.microsoftVerifiedDomains
  }))

  // init
  useEffect(
    () => {
      trackEventInAllServices(TRACKING_EVENTS.SETUP_FLOW.STEP_3_START_MICROSOFT)
    },
    // eslint-disable-next-line
    []
  )

  const onSelectChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      dispatch(setMsDomainName(e.target.value))
      trackEventInAllServices(TRACKING_EVENTS.SETUP_FLOW.STEP_3_SELECT_DOMAIN, { domain: e.target.value })
    },
    [dispatch]
  )

  return useMemo(
    () => [
      {
        msDomainName,
        verifiedDomains: verifiedDomains || []
      },
      {
        onSelectChange
      }
    ],
    [msDomainName, verifiedDomains, onSelectChange]
  )
}
